import React from 'react';

const MarketPanelStocksToWatch = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Stocks to Watch</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="stocks-to-watch">
            <thead>
              <tr>
                <th>Icon</th>
                <th>Stock Name</th>
                <th>Stock Insight</th>
                <th>Current Price</th>
                <th>Change</th>
                <th>% Change</th>
                <th>Volume</th>
                <th>Market Cap (₹ Cr)</th>
                <th>Watch Reason</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.icon || '-'}</td>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.stock_insight || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.change || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.watch_reason || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelStocksToWatch; 